
/* eslint-disable */
export const info = {
  'Procesos': 'Esta es la cantidad de procesos disponibles en el plan de tu organización.',
  'Postulantes': 'Esta es la cantidad de postulantes que puedes utilizar en cualquiera de tus procesos, sin contar los cupos disponibles en cada proceso en particular.',
  'Evaluaciones Gamificadas': 'Esta es la cantidad de Evaluaciones Gamificadas disponibles en tu organización para utilizar en cualquiera de tus procesos. A esto, se le suma la cantidad disponible en cada proceso si corresponde.'
}
